import type { CatalogProducts, Meter } from '@vy/types';
import type { CreditType } from '@vy/api-definition';
import {
  MeterProductRow,
  PRODUCT_TYPE,
  type CatalogProductsRow,
  type CreditTypeRow,
  type UnifiedProductRow,
} from './products-columns-type';

export function isMeterProductRow(row: UnifiedProductRow): row is MeterProductRow {
  return row.type === PRODUCT_TYPE.METERED;
}

export function isCatalogProductRow(row: UnifiedProductRow): row is CatalogProductsRow {
  return row.type === PRODUCT_TYPE.SERVICE;
}

export function isCreditTypeRow(row: UnifiedProductRow): row is CreditTypeRow {
  return row.type === PRODUCT_TYPE.CREDIT;
}

export const buildUnifiedProductRow = (
  meters: Meter[],
  catalogProducts: CatalogProducts[],
  creditTypes: CreditType[],
): UnifiedProductRow[] => {
  const metersWithType = buildMeterWithType(meters);
  const catalogProductsWithType = buildCatalogProductWithType(catalogProducts);
  const creditTypesWithType = buildCreditTypeWithType(creditTypes);

  return [...metersWithType, ...catalogProductsWithType, ...creditTypesWithType].sort(
    (a, b) => b.createdAt.getTime() - a.createdAt.getTime(),
  );
};

function buildMeterWithType(meters: Meter[]): MeterProductRow[] {
  return meters.map((meter) => ({ ...meter, type: PRODUCT_TYPE.METERED }));
}

function buildCatalogProductWithType(catalogProducts: CatalogProducts[]): CatalogProductsRow[] {
  return catalogProducts.map((product) => ({ ...product, type: PRODUCT_TYPE.SERVICE }));
}

function buildCreditTypeWithType(creditTypes: CreditType[]): CreditTypeRow[] {
  return creditTypes.map((creditType) => ({ ...creditType, type: PRODUCT_TYPE.CREDIT }));
}
